module.exports = __webpack_public_path__ + "img/SKMJ_ex1.8c4356b8.jpg";